import Clappr from "@clappr/player";

export class UnmuteButton {

  constructor(player) {
    this.player = player;
  }

  init() {
    console.log('INIT!!');
  }

  setPlayer(player) {
    this.player = player;
  }

  hideButton() {
    this._btn && this._btn.remove( );
  }

  showButton() {
    let $ = Clappr.$;
    this.hideButton( );
    let modalMsg =
      '<div class="ui ms_mute_btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>'+
      '<div class="listem-display-text"><b>Listen</b></div></div>';
    this._btn = $('<div>').addClass('ms_mute_btn_background').html(modalMsg);
    this.player.core.activeContainer && this.player.core.activeContainer.$el.prepend(this._btn);
    this._btn.on('click', () => {this.unmuteVideoEvent()});
    this.player.core.mediaControl.disable();
    this.player.core.mediaControl.el.style.visibility = "hidden"
  }

  unmuteVideoEvent() {
    this.player.unmute ();
    this.player.setVolume(100);
    this.hideButton( );
    this.player.core.mediaControl.enable ();
    this.player.core.mediaControl.el.style.visibility = ""
  }
}

export class ViewerCounterUI {
  constructor(player) {
    this.player = player;
  }

  init() {
    this.showCounter();
  }

  animateCounter(from, to) {
    const viewerCounterEl = Clappr.$(this.player.core.activeContainer.$el).find("#viewer_counter");
    if( viewerCounterEl ) {
      viewerCounterEl.data("vc-from", from).data("vc-to", to);

      let current = from;
      const increment = to > from ? 1 : -1;
      const duration = 200;
      const stepTime = Math.abs(Math.floor(duration / (to - from)));

      if( from === to ) {
        // if the same set the current view value
        viewerCounterEl.text(to);
      } else {
        const interval = setInterval(() => {
          if (current === to) {
            clearInterval(interval);
          } else {
            current += increment;
            viewerCounterEl.text(current);
          }
        }, stepTime);
      }
    }
  }

  showCounter( from=0, to=0 ) {
    let modalMsg = `<div id="viewer_counter" class="ui viewer_counter" data-vc-from='${from}' data-vc-to='${to}'>0</div>`;
    this.player.core.activeContainer && this.player.core.activeContainer.$el.prepend(modalMsg);
  }

  updateCount( from=0, to=0 ) {
    this.animateCounter(from, to);
  }
}